// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2342 ? "skylab.popsheet" : chunkId) + "." + {"2342":"7d13a021a74b4ffa4545","8290":"755d8f806d9ce655b67e"}[chunkId] + ".js";
};